import axios from 'axios';

import { baseUrl } from './index';

export const login = (email: string) => {
  let localStoragePoints: string | number | null =
    localStorage.getItem('cheerie.points');
  if (localStoragePoints) {
    localStoragePoints = Number(localStoragePoints);
  } else {
    localStoragePoints = 0;
  }

  return axios.put(`${baseUrl}/user/register`, {
    email,
    points: localStoragePoints,
  });
};

export const getMe = () => {
  return axios.get(`${baseUrl}/user/me`);
};

export const storeUserSearch = (query: string) => {
  return axios.post(`${baseUrl}/user/search`, { query });
};
